import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { concatLatestFrom } from '@ngrx/operators';
import * as PartnersListActions from '@hub-store/partners-list/partners-list.actions';
import * as PartnersListSelectors from '@hub-store/partners-list/partners-list.selectors';
import { map, of, switchMap, take, tap } from 'rxjs';
import { PartnersService } from '@hub-services/partners.service';
import { Partner } from '@hub-services/partner';
import { PartnerType } from './partner-type.enum';

@Injectable({ providedIn: 'root' })
export class AdminPartnersResolve  {
  constructor(private partnerService: PartnersService, private store: Store) { }

  resolve(route: ActivatedRouteSnapshot) {

    const selectedPartnerType = route.data.partnerType as PartnerType;

    return this.store.select(PartnersListSelectors.getPartnersByStatus)
      .pipe(
        concatLatestFrom(() => this.store.select(PartnersListSelectors.getPartnersType)),
        take(1),
        switchMap(([partners, partnerType]) => {

          if (partnerType !== selectedPartnerType) {
            // partner type has changed, we need to request a new list
            return this.requestPartnersList(selectedPartnerType);
          }

          return partners?.length && !route.queryParams?.partnerFromApi
            ? of(partners)
            : this.requestPartnersList(selectedPartnerType);
        }));
  }

  private requestPartnersList(selectedPartnerType: PartnerType) {
    return this.partnerService
      .getPartnersV2Observable(selectedPartnerType)
      .pipe(
        map(partners => this.sortAlphabetically(partners)),
        tap((partners: any) => {
          this.store.dispatch(PartnersListActions.setPartners({ partners }));
          this.store.dispatch(PartnersListActions.setPartnerType({ partnerType: selectedPartnerType }))
        })
      )
  }

  private sortAlphabetically(partners: Partner[]): Partner[] {
    return partners?.sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
  }
}
